import { CCAssessmentType } from "../../Physician/Models/CCEnrollment";
import { getDateWithOffset } from "../../Shared/Utility/GetDateWithOffset";
import CcAssessmentPathwayEnrollment, { CcAssessmentPathwayEnrollmentCertificate } from "./CcAssessmentPathwayEnrollment";

export default class UpdateCCAssessmentPathwayModel{
    constructor(pathwayEnrollment: CcAssessmentPathwayEnrollment) {
        this.cCEnrollmentId = pathwayEnrollment.ccEnrollmentId;
        this.cCEnrollmentCertificates = new Array<UpdateCCAssessmentPathwayCertificateModel>();

        for (var i = 0; i < pathwayEnrollment.ccEnrollmentCertificates.length; i++){
            this.cCEnrollmentCertificates.push(new UpdateCCAssessmentPathwayCertificateModel(pathwayEnrollment.ccEnrollmentCertificates[i]));
        }
    }

    cCEnrollmentId: number;
    cCEnrollmentCertificates: Array<UpdateCCAssessmentPathwayCertificateModel>
}

export class UpdateCCAssessmentPathwayCertificateModel{
    constructor(enrollmentCertificate: CcAssessmentPathwayEnrollmentCertificate){
        this.certificateId = enrollmentCertificate.certificateId;
        this.isEnrolled = enrollmentCertificate.isEnrolled;
        this.cCAssessmentType = enrollmentCertificate.ccAssessmentType;
        this.cCAssessmentAttestationDate = getDateWithOffset(enrollmentCertificate.ccAssessmentAttestationDate);
        this.lastArticleAssessmentEnrolledDate = getDateWithOffset(enrollmentCertificate.lastArticleAssessmentEnrolledDate);
        this.enrollmentStartDate = getDateWithOffset(enrollmentCertificate.enrollmentStartDate);
        this.enrollmentEndDate = getDateWithOffset(enrollmentCertificate.enrollmentEndDate);
        
    }

    certificateId: number;
    isEnrolled: boolean;
    cCAssessmentType: CCAssessmentType;
    cCAssessmentAttestationDate: Date;
    lastArticleAssessmentEnrolledDate: Date;
    enrollmentStartDate: Date;
    enrollmentEndDate: Date;
}